import { ReactNode, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';

export default function Layout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const isFullWidth = location.pathname.includes('/talent-manager');

  return (
    <div className="flex h-full text-white" style={{ background: '#0a0a0a' }}>
      {/* Mobile menu button */}
      <button
        onClick={() => setIsSidebarOpen(true)}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-lg bg-white/10 border border-white/10"
      >
        <Menu className="w-5 h-5 text-white" />
      </button>

      {/* Backdrop */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/70 z-40 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed lg:sticky top-0 left-0 z-50 w-64 h-full border-r border-white/[0.06] transform transition-transform duration-200 ease-in-out lg:translate-x-0 ${
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
        style={{ background: '#111111' }}
      >
        <Sidebar onClose={() => setIsSidebarOpen(false)} />
      </aside>

      {/* Main content */}
      <main className="flex-1 min-h-0 w-full lg:w-[calc(100%-16rem)] overflow-auto">
        {isFullWidth ? (
          <div className="h-full">
            <Outlet />
          </div>
        ) : (
          <div className="container mx-auto p-4 lg:p-6 pt-20 lg:pt-6 relative">
            <Outlet />
          </div>
        )}
      </main>
    </div>
  );
}